// extracted by mini-css-extract-plugin
export var fileUpload = "_fp-1";
export var modalButton = "_fp-0";